import React, { useState } from 'react';
import MuiExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MuiChip from '@material-ui/core/Chip';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import { useRouter } from 'next/router';
import { withStyles } from '@material-ui/core';
import MuiExpansionPanel from '@material-ui/core/ExpansionPanel';
import Typography from '@material-ui/core/Typography';
import styled from 'styled-components';
import qs from 'query-string';
import Button from '@material-ui/core/Button';
import MuiTextField from '@material-ui/core/TextField';
import NumberFormat, { NumberFormatValues } from 'react-number-format';

const ExpansionPanel = withStyles({
  root: {
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
})(MuiExpansionPanel);

const ExpansionPanelSummary = withStyles({
  content: {
    alignItems: 'center',
  },
})(MuiExpansionPanelSummary);

const PanelHeading = withStyles({
  h6: {
    width: '100%',
    fontWeight: 'normal',
    fontSize: '13px',
  },
})(Typography);
const Chip = styled(MuiChip)`
  font-size: 10px !important;
  background: ${({ theme }) => theme.colors.primary} !important;
`;
const Form = styled.form`
  display: flex;
  align-items: center;
  .MuiFormControl-root {
    margin-top: 10px;
    &:not(:first-child) {
      margin-left: 10px;
    }
  }
  button {
    padding: 0;
  }
`;
const StyledNumberFormat = styled(NumberFormat)`
  margin-top: 10px !important;
  width: 100%;
`;

type RentalPeriodPanel = {
  isWantedSearch: boolean;
};
const RentalPeriodPanel = ({ isWantedSearch }: RentalPeriodPanel) => {
  const router = useRouter();
  const { query } = router;
  const [minPeriod, setMinPeriod] = useState<string | null>(null);
  const [maxPeriod, setMaxPeriod] = useState<string | null>(null);

  const handleSubmit = () => {
    const qry = {
      ...query,
      rental_period: `${minPeriod && minPeriod.toString()}_${maxPeriod && maxPeriod.toString()}`,
    };
    if (isWantedSearch) {
      router.push(`/wanted-search?${qs.stringify(qry)}`);
    } else {
      router.push(`/search?${qs.stringify(qry)}`);
    }
  };

  const clearFilterHandler = () => {
    const qry = {
      ...query,
      rental_period: `${minPeriod && minPeriod.toString()}_${maxPeriod && maxPeriod.toString()}`,
    };
    delete qry.rental_period;
    setMaxPeriod(null);
    setMinPeriod(null);
    if (isWantedSearch) {
      router.push(`/wanted-search?${qs.stringify(qry)}`);
    } else {
      router.push(`/search?${qs.stringify(qry)}`);
    }
  };
  const [expanded, setExpanded] = React.useState(true);

  const handlePanelChange = (event: any, isExpanded: boolean) => {
    setExpanded(!!isExpanded);
  };

  let canSearch = false;
  if (minPeriod && maxPeriod) {
    canSearch = parseInt(minPeriod, 10) >= 0 && parseInt(maxPeriod, 10) >= 0;
  }
  return (
    <ExpansionPanel defaultExpanded expanded={expanded} onChange={handlePanelChange}>
      <ExpansionPanelSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <PanelHeading variant="h6">By Rental period</PanelHeading>
        {query.rental_period && (
          <Chip
            size="small"
            label={`${query.rental_period.toString().split('_')[0]} to ${
              query.rental_period.toString().split('_')[1]
            } days`}
            onDelete={() => clearFilterHandler()}
            color="primary"
          />
        )}
      </ExpansionPanelSummary>
      <ExpansionPanelDetails>
        <Form>
          <StyledNumberFormat
            size="small"
            allowNegative={false}
            value={minPeriod}
            variant="outlined"
            placeholder="Min period"
            customInput={MuiTextField}
            label="Min period"
            InputLabelProps={{ shrink: true }}
            onValueChange={(val: NumberFormatValues) => {
              const { value } = val;
              setMinPeriod(value);
            }}
          />
          <StyledNumberFormat
            size="small"
            allowNegative={false}
            value={maxPeriod}
            variant="outlined"
            placeholder="Max period"
            customInput={MuiTextField}
            label="Max period"
            InputLabelProps={{ shrink: true }}
            onValueChange={(val: NumberFormatValues) => {
              const { value } = val;
              setMaxPeriod(value);
            }}
          />
          <Button
            disabled={!query.rental_period && !canSearch}
            onClick={() => handleSubmit()}
            color="primary"
          >
            Go
          </Button>
        </Form>
      </ExpansionPanelDetails>
    </ExpansionPanel>
  );
};

export default RentalPeriodPanel;
